import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, finalize, from, Observable, tap } from 'rxjs';
import { RefundLine, RefundModel } from 'src/app/models/refund.model';
import { DbService } from './idb.service';
import { ConnectionManagerService } from '../storage/connection-manager.service';
import { ReturnDbService } from './return-db.service';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class CurrentRefundService {
  private returnSubject = new BehaviorSubject<RefundModel | null>(null);
  public return$: Observable<RefundModel | null> =
    this.returnSubject.asObservable();
  private refund: RefundModel | null = null;
  public loading = false;
  public errorText = '';
  public hasError = false;
  private loadingCount = 0;
  private db: DbService;
  private returnDb: ReturnDbService;

  constructor(private cm: ConnectionManagerService) {
    this.db = cm.getCurrentDb();
    this.returnDb = new ReturnDbService(this.db);
  }

  init(refundId?: string) {
    if (!refundId) {
      return;
    }

    this.db = this.cm.getCurrentDb();
    this.returnDb = new ReturnDbService(this.db);
    this.returnSubject = new BehaviorSubject<RefundModel | null>(null);
    this.return$ = this.returnSubject.asObservable();
    this.refund = null;
    this.hasError = false;
    this.errorText = '';

    this.loadReturn(refundId);
  }

  unsubAll() {
    this.refund = null;
    this.returnSubject.complete();
  }

  upd(rfnd: RefundModel) {

    if (rfnd.statusId !== 1) {
      throw new Error("Редактирование подтверждённого документа запрещено!");
    }

    this.loading = true;
    this.loadingCounter(true);
    return from(this.returnDb.updRefund(rfnd)).pipe(
      tap((r) => {
        this.linkValues(r);
      }),
      catchError((err) => { console.log(err); throw err }),
      finalize(() => {
        this.loadingCounter(false)
      })
    );
  }

  public addOrUpdateItem(newLineEvent: RefundLine): void {
    if (!this.refund) return;
    if (this.loading) return;

    const newLine = newLineEvent as RefundLine;

    const check = this.refund.items.findIndex(
      (a) => a.goodId === newLine.goodId
    );

    // попытка добавить товар, который есть в возврате.
    // считаем, что нужно просто исправить кол-во
    if (check >= 0) {
      this.refund.items[check].amount = newLine.amount;
      this.refund.items[check].summa = newLine.amount * newLine.price;
      this.refund.items[check].price = newLine.price;
    }
    else {
      newLine.orderId = this.refund.id;
      newLine.id = uuidv4();
      newLine.summa = newLine.amount * newLine.price;

      // ищем строку, чтобы вставка не нарушала алфавитный порядок
      const idx = this.refund.items.findIndex(
        (a) => newLine.good.localeCompare(a.good) < 0
      );

      if (idx < 0) {
        this.refund.items.push(newLine);
      } else {
        //  idx = idx - 1
        this.refund.items.splice(idx, 0, newLine);
      }
    }

    this.upd(this.refund).subscribe();
  }

  private loadReturn(refundId: string) {
    this.loadingCounter(true);
    this.returnDb
      .getRefund(refundId)
      .then((r) => {
        if (r) {
          this.linkValues(r);
        }
      })
      .catch((err) => {
        this.hasError = true;
        this.errorText = `не удалось загрузить возврат - ${err?.message}`;
      })
      .finally(() => {
        this.loadingCounter(false);
      });
  }

  private linkValues(value: RefundModel) {
    this.returnSubject.next(value);
    this.refund = value;
  }
  private loadingCounter(plus: boolean, count = 1) {
    if (plus) {
      this.loadingCount += count;
    } else {
      this.loadingCount -= count;
    }
    this.loading = this.loadingCount > 0;
  }


  public deleteItem(itemId: string): void {

    if (!this.refund) return
    if (this.refund.statusId !== 1) {
      return
    }
    if (this.loading) return
    this.loading = true

    const idx = this.refund.items.findIndex(a => a.goodId === itemId)

    if (idx < 0) {
      console.error("попытка удалить несуществующую строку")
      return
    }

    this.refund.items.splice(idx, 1)

    this.upd(this.refund).subscribe()


  }

}
